import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";

const HelpSupport = () => {
  return (
    <div className="mt-4">
      <Link to="/main/profile">
        <div className="flex items-center gap-4 font-bold text-purple-800 hover:text-purple-500">
          <MdArrowBack className="flex h-4 w-4" />
          <p>Back to Settings</p>
        </div>
      </Link>
      <div className="mt-4">
        <div className="align-start flex flex-col rounded-lg bg-gradient-to-b from-gray-50 to-purple-50 p-2 p-4 text-left shadow-md">
          <h4 className="text-lg font-medium text-gray-900">Contact Support</h4>
          <div className="w-full border-b border-gray-200 pb-4">
            <div className="mt-6">
              <div className="w-full max-w-[400px]">
                <p className="w-full font-medium text-gray-800">Email</p>
                <input
                  type="email"
                  className="mt-2 w-full rounded-md bg-purple-50 py-2 focus:outline-none focus:ring-1 focus:ring-purple-500"
                  value="support@selliox.com"
                  disabled
                />
              </div>
            </div>
          </div>
          <h4 className="mt-6 text-lg font-medium text-gray-900">
            Bugs or technical issues
          </h4>
          <div className="w-full pb-4">
            <p className="mt-2 text-sm text-gray-800">
              Report bugs or technical issues.
            </p>
            <div className="mt-4">
              <button
                className="rounded-full border-2 border-purple-800 px-4 py-2 font-bold text-purple-800 transition duration-150 ease-in-out hover:bg-purple-50 hover:text-purple-500"
                onClick={() => {
                  const email = "support@selliox.com";
                  const subject = encodeURIComponent("Riplestack Support");
                  const body = encodeURIComponent(
                    "Hello, I need assistance with..."
                  );

                  window.open(
                    `mailto:${email}?subject=${subject}&body=${body}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                Report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpSupport;
